export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_AUTH_STATE = 'SET_AUTH_STATE';
export const UPDATE_SELF_PERMISSION = 'UPDATE_SELF_PERMISSION';

export const SET_PROJECTS = 'SET_PROJECTS';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
